export default __webpack_public_path__ + "static/media/masthead-angle-top-right.9a3ca0ea.svg";